// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors-primary": "#003c6c",
	"colors-alquant": "#007272",
	"colors-success": "#28c76f",
	"colors-danger": "#ea5455",
	"colors-warning": "#ffba00",
	"colors-grey": "#b8c2cc",
	"colors-grey-light": "#dae1e7",
	"colors-invisible": "rgba(0, 0, 0, 0)",
	"colors-benchmark": "#8d8c8c",
	"colors-exposure": "#1f77b4",
	"typography-font-family-sans-serif": "\"Montserrat\", helvetica, arial, sans-serif"
};
export default ___CSS_LOADER_EXPORT___;
